import React from 'react';

import PassBox from "./PassBox";

export default function PassGroup(props) {
  return (
    <>
      {
        props.data.map((item, index) => {
          return (
            <div key={`pass-group-${index}`} className="passGroup">
              <div className={`passSectionTitleWrap_type${item.type}`}>
                <em className="passSectionTitle">{item.title}</em>
                {item.sub_title && (<p className="passSectionText">{item.sub_title}</p>)}
              </div>
              {
                item.products &&
                (<div key={`pass-group-product-${index}`} className="passGroupList">
                  <PassBox data={item.products} type={item.type} group={item.group} groupTitle={item.title} loginJwt={props.loginJwt} isAndroid={props.isAndroid} isIOS={props.isIOS} isSbsApp={props.isSbsApp} inappbillingHandler={props.inappbillingHandler} platform={props.platform} displayLang={props.displayLang} lang={props.lang} />
                </div>)
              }
            </div>
          )
        })
      }
    </>
  );
}
